import React, { JSX } from 'react';
import contactImg from '../../assets/Img/static-img/contactImg.png'; // <-- place your image here
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import '../../index.css';
import { Seo, buildFAQSchema, buildWebPageSchema } from '../../core/seo';

const CONTACT_FAQS = [
  {
    question: 'How do I contact HirePanther support?',
    answer:
      'You can reach HirePanther support by emailing support@hirepanther.ca, using the contact form on this page, or submitting a support ticket at uat.hirepanther.ca/support-ticket.',
  },
  {
    question: 'What is the best way to report a safety issue?',
    answer:
      'For urgent safety matters, call local emergency services first. For platform safety or claims, email safety@hirepanther.ca or use the report form at uat.hirepanther.ca/report-issue.',
  },
];

const contactFaqSchema = buildFAQSchema({
  questions: CONTACT_FAQS,
  url: 'https://uat.hirepanther.ca/contact',
});
const contactWebPageSchema = buildWebPageSchema({
  name: 'Contact HirePanther',
  description:
    'Get in touch with HirePanther. Send a message or reach our team for support and inquiries.',
  url: 'https://uat.hirepanther.ca/contact',
  mainEntity: contactFaqSchema,
});

type CardProps = {
  icon: JSX.Element;
  title: string;
  subtitle: string;
  content: string;
};

const ContactInfoCard: React.FC<CardProps> = ({
  icon,
  title,
  subtitle,
  content,
}) => (
  <div className="bg-white shadow-md rounded-xl p-6 text-center w-64">
    <div className="text-[#0CA7C1] flex justify-center text-3xl mb-3">
      {icon}
    </div>
    <h4 className="text-card-title">{title}</h4>
    <h5 className="text-card-subtitle mb-2">{subtitle}</h5>
    <p className="text-card-content text-sm">{content}</p>
  </div>
);

const ContactForm: React.FC = () => (
  <form
    className="flex flex-col gap-4 w-full"
    action="https://api.web3forms.com/submit"
    method="POST"
  >
    <input
      type="hidden"
      name="access_key"
      value="042d2439-3b31-4560-b3c9-6a3020652b93"
    />

    <div className="flex gap-4 flex-wrap">
      <input
        type="text"
        name="name"
        placeholder="Your Name"
        className="contact-form-field "
        required
      />
      <input
        type="email"
        name="email"
        placeholder="Your Email"
        className="contact-form-field"
        required
      />
    </div>
    <div className="flex gap-4 flex-wrap">
      <input
        type="tel"
        name="phone"
        placeholder="Phone Number"
        className="contact-form-field"
      />
      <input
        type="text"
        name="subject"
        placeholder="Subject"
        className="contact-form-field"
      />
    </div>
    <textarea
      name="message"
      rows={5}
      placeholder="Your Message Here..."
      className="contact-form-field"
    ></textarea>
    <button type="submit" className="contact-form-button">
      Send Message
    </button>
  </form>
);

const ContactUs: React.FC = () => {
  return (
    <div className="px-6 py-12 font-sans text-[#163544]">
      <Seo
        title="Contact Us"
        description="Get in touch with HirePanther. Send a message or reach our team for support and inquiries."
        canonicalPath="/contact"
        structuredData={[contactFaqSchema, contactWebPageSchema]}
      />
      {/* Header */}
      <h3 className="text-normal text-lg mb-2 text-center">Contact Us</h3>
      <h1 className="text-contact-heading md:text-4xl mb-10 text-center">
        Feel Free to Contact With Us{' '}
      </h1>

      {/* Info Cards */}
      <div className="flex flex-wrap justify-center gap-6 mb-12">
        <ContactInfoCard
          icon={<FaEnvelope />}
          title="Drop a line"
          subtitle="Mail Us"
          content="contact@hirepanther.ca"
        />
        <ContactInfoCard
          icon={<FaPhone />}
          title="24/7 Service"
          subtitle="Call Us"
          content="+1 (647) 960-0666"
        />
        <ContactInfoCard
          icon={<FaMapMarkerAlt />}
          title="Location"
          subtitle="Visit Us"
          content="2727 Steeles Ave W,Unit 103-1030, Toronto, ON M3J 3G9, Canada"
        />
      </div>

      {/* Body */}
      <div className="flex flex-col md:flex-row items-center justify-center gap-10">
        <div className="max-w-sm">
          <img
            src={contactImg}
            alt="Contact illustration"
            className="w-full h-auto"
          />
        </div>
        <div className="w-full max-w-lg">
          <h2 className="text-form-heading mb-5">Send your Message To Us</h2>
          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
